import React from 'react';
import { CancelIcon } from '../../assets/icons/icons';
import './style.css';

// Props:
// - isOpen: bool
// - onClose: fn
// - exercise: { name, instructions, primaryMuscles, images, id }
// - getImage: fn(relativePath) => src
export default function ExerciseModal({ isOpen, onClose, exercise, getImage }) {
  if (!isOpen || !exercise) return null;

  const {
    name,
    instructions = [],
    primaryMuscles = [],
    images = [],
    description = '',
  } = exercise;

  const fallbackSteps = description
    ? description.split(/\n+/).map((line) => line.replace(/^\d+\.\s*/, '').trim()).filter(Boolean)
    : [];
  const steps = instructions.length ? instructions : fallbackSteps;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content exercise-modal" onClick={(e) => e.stopPropagation()}>
        <div className="goal-accordion-container">
          <h3>{name}</h3>
          <CancelIcon onClick={onClose} className="cancel-icon" />
        </div>

        {images?.length > 0 && (
          <div className="exercise-images">
            {images.map((img, i) => (
              <img key={i} src={getImage(img)} alt={`${name} ${i+1}`} />
            ))}
          </div>
        )}

        <div className="exercise-meta">
          {primaryMuscles.length > 0 && (
            <p><strong>Primary:</strong> {primaryMuscles.join(', ')}</p>
          )}
        </div>

        {steps?.length > 0 && (
          <div className="exercise-steps">
            <h4>How to do it</h4>
            <ol>
              {steps.map((step, idx) => (
                <li key={idx}>{step}</li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </div>
  );
}
